import EditorBase from '../../EditorBase'

//	TODO: Support LI, UL, DL
export const EditorList = (props: any) => {
	const tagName = props.tagName || 'ul'
	return <EditorBase {...props} tagName={tagName} />
}
